import axios from "axios";
// const baseDomain = "http://192.168.18.12:3110/";
const baseDomain = "https://linkdao-defi-bonanza.linkdao.cc/";
const baseURL = `${baseDomain}`;
const getToken = () => {
  let ls = localStorage.getItem("token");
  if (ls) {
    return ls;
  } else {
    return "";
  }
};
let axiosObj: any;
axiosObj = axios.create({
  baseURL,
  headers: {
    Authorization: getToken(),
  },
});

export default axiosObj;
